
import moment                   from 'moment-timezone'
import store                    from '@/store'
import enums                    from '@/utils/enums'
import logTrace                 from '@/services/logTrace'
import { NOTIFICATIONS, USER }  from '@/utils/constants'

export default {
    [NOTIFICATIONS.LOAD_VISUALIZED]: async ({ commit }, { ctx }) => {
      const params = { filter: { userId: store.getters[USER.GET_USER]._id }}

      const {
        items
      } = await ctx.requestService(`${process.env.CRUD_API_GET}/notification`, 'GET', 
      { 
        params, 
        localErrorHandling: true
      })

      if (items) {
        commit(NOTIFICATIONS.MUTATE_VISUALIZED, items[0] ? items[0].visualized : {})
        commit(NOTIFICATIONS.MUTATE_ID, items[0] ? items[0]._id : null)
      }
    },

    [NOTIFICATIONS.SAVE_VISUALIZED]: async ({ state, commit }, payload) => {
      try {
        commit(NOTIFICATIONS.LOADING, true)

        const { ctx, notification, fromNotifications = false } = payload

        if (fromNotifications) {
          logTrace({ action: enums.logTraceActions.notificationLink, details: notification })
        }

        if (!notification.id || state.visualized[notification.id]) return

        const now = moment().toISOString()

        state.visualized[notification.id] = { viewedAt: now, type: notification.type }

        const body = { table: 'notification', data: { visualized: state.visualized }}

        let type = ''
        if (state.id) {
          type = 'update'
          body.data._id = state.id
        } else {
          type = 'save'
          body.data.userId = store.getters[USER.GET_USER]._id
        }

        const options = [null, true, true, null, false]
        const response = await ctx.requestService(`${process.env.CRUD_API_SAVE}/${type}`, 'POST', 
        { 
          data: body, 
          localErrorHandling: true,
          useLoading: true
        })

        commit(NOTIFICATIONS.MUTATE_ID, response.data._id)
      } finally {
        commit(NOTIFICATIONS.LOADING, false)
      }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/notifications/actions.js